import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomDashboardPage, ChartDetailsPage } from './index';
import { CanActivateGuard } from './../shared/index';


export const AnalyticsRoutes: Routes = [
    {
        path: 'analytics/chartdetails/:chartKey',
        component: ChartDetailsPage,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'analytics/chartdetails',
        component: ChartDetailsPage,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'analytics/customdashboard',
        component: CustomDashboardPage,
        canActivate: [CanActivateGuard]
    }
];

export const AnalyticsRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(AnalyticsRoutes);
